import { isLinked, type LinkableField } from '@synqo/frontend-component-library';

interface WithContent {
    content: LinkableField;
}

/** What the material of a set of container actions comes to. */
export interface MaterialSummary {
    /** The material every action names; undefined while none is named or the actions disagree. */
    material: LinkableField | undefined;
    isMixed: boolean;
}

/** The distinct materials the actions name, first mention first. */
// @ai-generated 2026-09-30T11:45:02+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function distinctMaterials(actions: readonly WithContent[]): LinkableField[] {
    const byId = new Map<string, LinkableField>();

    actions.forEach(({ content }) => {
        if (isLinked(content) && !byId.has(content.foreign_key ?? '')) {
            byId.set(content.foreign_key ?? '', content);
        }
    });

    return [...byId.values()];
}

/** The materials a list shows in place of its positions, which is only while it has no position at all. */
// @ai-generated 2026-09-30T11:45:02+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function materialsInPlaceOfPositions(
    positions: readonly unknown[],
    actions: readonly WithContent[],
): LinkableField[] {
    return positions.length === 0 ? distinctMaterials(actions) : [];
}

/** Whether the actions agree on their material; an action without one disagrees with one that has one. */
// @ai-generated 2026-09-30T11:45:02+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function summarizeMaterial(actions: readonly WithContent[]): MaterialSummary {
    const ids = new Set(actions.map(({ content }) => (isLinked(content) ? content.foreign_key : undefined)));

    if (ids.size !== 1) {
        return { material: undefined, isMixed: ids.size > 1 };
    }

    return { material: distinctMaterials(actions)[0], isMixed: false };
}
